
import { ContainerComponent, wrap } from 'AppReact';

import Controller from './controller';
import {
  FlexCenterBetweenWrapper, FlexCenterWrapper, Mr2, Mt8, FullWidthFlexBoxWrapper, Mt5, Mr5,
  SettingsContainerWrapper, Mr3, CustomBackgroundWrapper, Width500, TextCenterWrapper, Mt4,
  Ml3, Mb5
} from 'wrappers';
import { SolidButton, TabButton, TextButton, IconTextButton } from 'molecules';
import { SecondaryTextLg, Icon, SecondaryTextBase } from 'atoms';
import {
  NewMultiPropertySelector, InputWithSaveButton, InspectionsTagRow,
} from 'containers';
import { SavvyTechSvg, DefaultLabelIconSvg, PlusSignSvg } from 'components/icons';
import Badge from '../../apps/admin/applicationSettings/modals/newBadge/containers/body/containers/badgeCard';
import { textEllipsis } from 'utils/ellipsis';
import { getObjectIcons, tagColors } from 'utils';
import internalState from './internalState';
import { TagSvg } from 'utils/dropdownIcons/icons';

const isIncludeProperties = (property_ids, group_ids, selectedPropertyIds, selectedGroupIds) => {
  let template_property_ids = [...property_ids];
  if (group_ids?.length > 0) {
    group_ids.map(id => {
      let group = window.groups?.find(group => group.id === id);
      if (group && group.properties.length > 0) {
        template_property_ids = [...new Set([...template_property_ids, ...group.properties])];
      }
    });
  }

  let filter_property_ids = [...selectedPropertyIds];
  if (selectedGroupIds.length > 0) {
    selectedGroupIds.map(id => {
      let group = window.groups?.find(group => group.id === id);
      if (group && group.properties.length > 0) {
        filter_property_ids = [...new Set([...filter_property_ids, ...group.properties])];
      }
    });
  }

  return filter_property_ids.length === 0 || template_property_ids.some(item => filter_property_ids.includes(item))
};


export const definition = {
  name: "InspectionTemplates",
  controller: Controller,
  initialProps: ({ inspectionTemplates, properties, groups, priorities, inspectionTags }) => ({ inspectionTemplates, properties, groups, priorities, inspectionTags }),
  props: internalState,
  elements: [

    {
      wrapper: FlexCenterBetweenWrapper,
      name: 'TitleWrapper',
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'Title',
          elements: [
            {
              component: wrap(Icon, Mr2),
              name: 'Icon',
              displayValue: ({ }) => SavvyTechSvg({ width: 26, height: 26 })
            },
            {
              component: SecondaryTextLg,
              name: 'Title',
              displayValue: ({ }) => 'Inspections'
            }
          ]
        },
        {
          wrapper: FlexCenterWrapper,
          name: '__transparent__',
          elements: [
            {
              component: wrap(NewMultiPropertySelector, Mr3),
              name: 'PropertyContainer',
              bindings: ({ selectedPropertyIds, selectedGroupIds }) => ({ properties: window?.properties ?? [], groups: window?.groups ?? [], selectedPropertyIds, selectedGroupIds })
            },
            {
              wrapper: FlexCenterWrapper,
              name: 'Buttons',
              elements: [
                {
                  component: SolidButton,
                  name: 'Button',
                  bindings: ({ }) => ({ title: '+ Add inspection template', big: true })
                }
              ]
            },
          ]
        }
      ]
    },
    {
      wrapper: wrap(FlexCenterWrapper, Mt8),
      name: 'Tabs',
      elements: [
        {
          component: TabButton,
          name: "Active",
          displayState: ({ selectedTab }) => ({ selected: selectedTab === 'active_templates' }),
          bindings: ({ }) => ({ title: 'Active Templates', icon: DefaultLabelIconSvg({ width: 20, height: 20 }) }),
        },
        {
          component: TabButton,
          name: "Deactivated",
          displayState: ({ selectedTab }) => ({ selected: selectedTab === 'deactivated_templates' }),
          bindings: ({ }) => ({ title: 'Deactivated Templates', icon: DefaultLabelIconSvg({ width: 20, height: 20, pause: true }) }),
        },
        {
          component: TabButton,
          name: "Tags",
          displayState: ({ selectedTab }) => ({ selected: selectedTab === 'tags' }),
          bindings: ({ }) => ({ title: 'Tags', icon: TagSvg({ width: 20, height: 20 }) }),
        }
      ]
    },
    {
      wrapper: wrap(FullWidthFlexBoxWrapper, Mt5),
      name: 'Templates',
      renderIf: ({ selectedTab }) => ['active_templates', 'deactivated_templates'].includes(selectedTab),
      elements: [
        {
          component: wrap(wrap(Badge, Mr5), Mt5),
          renderIf: ({ inspectionTemplate, selectedPropertyIds, selectedGroupIds, selectedTab }) => {
            
            let isPropertyInclude = isIncludeProperties(inspectionTemplate?.property_ids ?? [], inspectionTemplate?.group_ids ?? [], selectedPropertyIds, selectedGroupIds);
            if (selectedTab === 'active_templates') {
              return inspectionTemplate.active && isPropertyInclude
            }
            return !inspectionTemplate.active && isPropertyInclude
          },
          isListOf: 'inspectionTemplates',
          name: 'Badge',
          bindings: ({ inspectionTemplate }) => ({ icons: getObjectIcons({}), badge: { ...inspectionTemplate, image: inspectionTemplate.icon && Object.keys(getObjectIcons({})).includes(inspectionTemplate.icon) ? inspectionTemplate.icon : 'Hibiscus', description: textEllipsis(inspectionTemplate.items?.map(o => o.name)?.join(', ') ?? '', 60) } })
        },
        {
          component: SecondaryTextBase,
          name: 'NoTemplate',
          renderIf: ({ inspectionTemplates, selectedPropertyIds, selectedGroupIds, selectedTab }) => {
            return inspectionTemplates.filter(inspectionTemplate => {
              let isPropertyInclude = isIncludeProperties(inspectionTemplate?.property_ids ?? [], inspectionTemplate?.group_ids ?? [], selectedPropertyIds, selectedGroupIds);
              if (selectedTab === 'active_templates') {
                return inspectionTemplate.active && isPropertyInclude
              }
              return !inspectionTemplate.active && isPropertyInclude
            })?.length === 0;
          },
          displayValue: ({ }) => 'No template for the selected properties'
        }
      ]
    },
    {
      wrapper: Mt5,
      name: '__transparent__',
      renderIf: ({ selectedTab }) => selectedTab === 'tags',
      elements: [
        {
          wrapper: CustomBackgroundWrapper,
          name: 'TagsWrapper',
          displayState: ({ }) => ({
            borderRadius: '12px', border: '1px solid #E3E3E3', background: '#FFFFFF', padding: '24px',
            flexDirection: 'column'
          }),
          elements: [
            {
              component: wrap(wrap(IconTextButton, Mb5), FullWidthFlexBoxWrapper),
              name: 'AddNew',
              renderIf: ({ inspectionTags, visibleTagInput }) => inspectionTags?.filter(t => t.is_active)?.length > 0 && !visibleTagInput,
              bindings: ({ child }) => ({ child, icon: PlusSignSvg({}), title: 'Add a new tag' })
            },
            {
              wrapper: CustomBackgroundWrapper,
              name: '__transparent__',
              renderIf: ({ inspectionTags, visibleTagInput }) => {
                return (!inspectionTags || inspectionTags?.filter(t => t.is_active).length === 0) && !visibleTagInput
              },
              displayState: ({ }) => ({ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }),
              elements: [
                {
                  component: wrap(wrap(SecondaryTextBase, Width500), TextCenterWrapper),
                  name: 'NoTagsText',
                  displayValue: ({ }) => 'Here you can create custom tags for your inspections, to help classify, organize and add priorities to your inspection items'
                },
                {
                  component: wrap(SolidButton, Mt4),
                  name: 'Button',
                  bindings: ({ }) => ({ title: '+ Create an inspection tag', big: true })
                },
              ]
            },
            {
              wrapper: FlexCenterBetweenWrapper,
              name: 'InputWrapper',
              renderIf: ({ visibleTagInput }) => visibleTagInput,
              elements: [
                {
                  component: InputWithSaveButton,
                  name: 'TagsInput',
                  bindings: ({ inspectionTags, properties }) => {
                    return ({ properties, inspectionTags, tagColors, label: ' ', value: '', buttonText: 'Save', placeholder: 'Start typing to create a tag', maxLength: 25 })
                  },
                },
                {
                  component: wrap(TextButton, Ml3),
                  name: 'Cancel',
                  bindings: ({ }) => ({ title: "Cancel" }),
                },
              ]
            },
            {
              component: wrap(InspectionsTagRow, Mt4),
              name: 'Tag',
              isListOf: { tag: ({ inspectionTags }) => inspectionTags.filter(t => t.is_active) },
              renderIf: ({ tag, selectedPropertyIds, selectedGroupIds }) => isIncludeProperties(tag?.property_ids ?? [], tag?.group_ids ?? [], selectedPropertyIds, selectedGroupIds),
              bindings: ({ tag, priorities, properties, groups }) => ({ tag, maxLength: 25, priorities, properties, groups }),
            },
          ]
        },
      ]
    }
  ]
}

export default wrap(ContainerComponent(definition), SettingsContainerWrapper);
